/** Capas de fondo compartidas — respeta light/dark del ThemeProvider */
export function PublicPageBackdrop({ variant = 'default' }: { variant?: 'default' | 'arena' }) {
  return (
    <div className="pointer-events-none fixed inset-0 z-0" aria-hidden>
      <div className="absolute inset-0 bg-background" />
      <div className="absolute inset-0 bg-landing-mesh" />
      <div
        className={
          variant === 'arena'
            ? 'absolute inset-0 bg-arena-mesh'
            : 'absolute inset-0 bg-glow-radial opacity-50 dark:opacity-80'
        }
      />
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.06] dark:opacity-[0.16]" />
      {/* Scanlines solo en dark — en light ensucian la lectura */}
      <div className="absolute inset-0 bg-scanlines hidden dark:block opacity-40" />
      <div className="absolute inset-0 bg-noise" />
    </div>
  );
}
